import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {CommunicationService} from '../../../services/communication.service';
import {TranslateService} from '@ngx-translate/core';
import {PreferencesService} from '../../../services/preferences.service';
import {Router} from '@angular/router';
import {ListingsService} from '../../../services/listings.service';
import {FiltersCommercialComponent} from './filters-commercial.component';
import {Filters} from '../../../classes/user-preferences';
import {Helper} from '../../../classes/helper';
import {SelectOption} from '../../forms/select/select.component';

@Component({
  selector: 'app-filters-commercial-mobile',
  templateUrl: 'filters-commercial.mobile.component.html',
  styleUrls: ['../filters.component.scss', '../filters.mobile.component.scss', 'filters-commercial.mobile.component.scss']
})
export class FiltersCommercialMobileComponent extends FiltersCommercialComponent implements AfterViewInit, OnInit {
  @Output() closed = new EventEmitter<void>();
  placeholder: string; // Search Input Placeholder
  listingsAvailable: number;

  constructor(protected preferencesService: PreferencesService,
              protected communicationService: CommunicationService,
              protected translateService: TranslateService,
              protected router: Router,
              protected listingsService: ListingsService,
              protected fb: FormBuilder,
              protected cd: ChangeDetectorRef) {
    super(preferencesService, communicationService, translateService, router, listingsService, fb, cd);
    this.filtersForm.addControl('price', this.fb.control({}));
    this.filtersForm.addControl('searchInputText', this.fb.control(''));
    // code below removes the unnecessary items from the array objects for mobile
    this.sqftOptions.splice(0, 1);
    this.storiesOptions.splice(0, 1);
    this.unitsOptions.splice(0, 1);
    this.totalAcresOptions.splice(0, 1);
    this.parkingOptions.splice(0, 1);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addSub(this.communicationService.searchResultsAvailable.subscribe(results => {
      this.listingsAvailable = results;
      document.querySelector('app-drawer .drawer-sub-title-right').innerHTML = this.translateService.instant('filters.n-results', {n: results});
    }));
    this.addSub(this.communicationService.searching.activeSearchText.subscribe((text) => this.placeholder = text));
  }

  onSubmit() {
    this.closed.emit();
  }

  onReset() {
    super.onReset();
    this._resetForm();
    this.broadcastChangedFilters();
  }

  _resetForm() {
    super._resetForm();
    // Reset price and/or price per square foot
    this.filtersForm.patchValue({
      price: {}
    });
    this.clearBusinessTypes();
    this.clearListingTypes();
  }

  broadcastChangedFilters() {
    const value: Filters = Object.assign(new Filters(), this.filtersForm.value);
    if (this.isPricePerSqft) {
      value.pricePerSqFt.min = this.filtersForm.controls['price'].value.min;
      value.pricePerSqFt.max = this.filtersForm.controls['price'].value.max;
      value.price = {};
    } else {
      value.price.min = this.filtersForm.controls['price'].value.min;
      value.price.max = this.filtersForm.controls['price'].value.max;
      value.pricePerSqFt = {};
    }
    value.rentalsOnly = this.onlyRentals;
    this._preferencesService.updateFilters(value);
    this.communicationService.searchParametersChanged.next();
  }
}

